module.exports = __webpack_public_path__ + "static/media/menu-icon.37ddef89.svg";